// ============================================================
// DM-LMS — RequireRole Guard
// DRY: one component enforces role-based access for all layouts.
// ============================================================

import { Navigate } from "react-router-dom";
import type { Role }  from "@dm-lms/shared/types";
import { useAuth }   from "../../hooks/useAuth.js";

interface RequireRoleProps {
  role:     Role;
  children: React.ReactNode;
}

export default function RequireRole({ role, children }: RequireRoleProps) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (!user) return <Navigate to="/app/login" replace />;

  if (user.role !== role) {
    // Redirect to their correct dashboard, not a 403 page
    return <Navigate to={`/app/${user.role}`} replace />;
  }

  return <>{children}</>;
}
